import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import UpdateWashingMethodForm from '@/components/pages/WashingMethods/Update/Form'
import UpdateWashingMethodPageHeader from '@/components/pages/WashingMethods/Update/PageHeader'
import { API_DEFAULT_PAGE, API_LIMIT } from '@/constants/api'
import { useCustomers } from '@/pages/Customer/Customers.hooks'
import { UpdateWashingMethodRequest } from '@/types/apis/washingMethods/UpdateWashingMethodRequest'

import { useGetWashingMethod, useUpdateWashingMethods } from './Update.hooks'

const UpdateWashingMethod = () => {
  const params = useParams<{ id: string }>()
  const { updateWashingMethod, loading: updateLoading } = useUpdateWashingMethods()

  const { getCustomers, getCustomersResponse } = useCustomers()

  const { getWashingMethod, loading: getLoading, response: getWashingMethodResponse } = useGetWashingMethod()

  const machineId = Number(params.id)

  const handleSubmitForm = async (formValues: UpdateWashingMethodRequest) => {
    await updateWashingMethod({
      ...formValues,
      id: machineId,
    })
  }

  useEffect(() => {
    getWashingMethod({ id: machineId })
    getCustomers({
      page: API_DEFAULT_PAGE,
      limit: API_LIMIT,
    })
  }, [machineId, params.id, getWashingMethod, getCustomers])

  return (
    <>
      <UpdateWashingMethodPageHeader />
      <UpdateWashingMethodForm
        {...{ updateLoading, getLoading, getWashingMethodResponse, customers: getCustomersResponse?.items }}
        onSubmit={handleSubmitForm}
      />
    </>
  )
}

UpdateWashingMethod.displayName = 'UpdateWashingMethod'
export default UpdateWashingMethod
